var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"grid-layout-container",style:({
    'grid-template-columns': _vm.gridTemplateColumns,
    'grid-auto-rows': ("" + _vm.itemHeight),
    'grid-gap': _vm.gap,
    'max-width': _vm.maxWidth,
  }),attrs:{"data-cy":"GridLayoutContainer"}},[_vm._t("default",null,{"default":""})],2)}
var staticRenderFns = []

export { render, staticRenderFns }